module.exports = __webpack_public_path__ + "assets/img/img256.6344a35d.png";